import Base64 from './base64';

// Local URL
//export const SHOPFLOOR_API_BASE_URL = "https://localhost:44306/api/";
// DEV URL
export const SHOPFLOOR_API_BASE_URL = "https://dev.flagstone.tech/mysoft.shopfloor.api/api/";
// QUA URL
//export const SHOPFLOOR_API_BASE_URL = "https://qua.flagstone.tech/mysoft.shopfloor.api/api/";
// SRVOneFigure IIS url
// export const SHOPFLOOR_API_BASE_URL = "http://192.168.8.15/Mysoft.shopfloor.API/api/";

export const API_USER_NAME = "tmsAppUser";
export const API_PASSWORD = "faWUC96wYzCk";

export const API_ACTION_GET_RESTARTABLE_SERVICES = "Services/GetServicesByAppID";
export const API_ACTION_RESTART_SERVICE = "Services/RestartService";

export function ComposeUri(baseAddress, action){
    // console.log(baseAddress + action);
    return baseAddress + action;
}

export function ComposeAuthToken(){
    return 'Basic ' + Base64.btoa(API_USER_NAME + ':' + API_PASSWORD);
}